module.exports = __webpack_public_path__ + "files/frontend.ab1eb282.pdf";